<template>
  <div class="bqv2-header">
    <!-- <div
      alt=""
      :style="{ 'background-image': 'url(' + bg + ')' }"
      class="bqv2-header-img"
    ></div> -->
    <!-- :arrow='hover' -->
    <el-carousel :interval="5000" :autoplay="true" class="bqv2-header-img">
      <el-carousel-item
        v-for="(item, index) in bgc"
        class="bqv2-img"
        :style="{ 'background-image': 'url(' + item.img + ')' }"
        :key="index"
        @click.native="swiperClick(item)"
      >
      </el-carousel-item>
    </el-carousel>

    <div class="bqv2-header-wrapper" style="margin: 0 auto">
      <div class="bqv2-header-title">
        <img
          :src="logo"
          alt=""
          class="bqv2-header-title-logo pointer"
          @click="nav(0)"
        />

        <div class="bqv2-header-title-content pointer" @click="nav(0)">
          <!-- 湖北版权综合服务平台 -->
        </div>
        <ul>
          <li
            v-for="(item, index) in list"
            :key="index"
            class="pointer"
            @click="nav(index)"
            :class="
              index == 0 && cur == index
                ? 'activeee'
                : cur == index
                ? 'activeee1'
                : ''
            "
          >
            {{ item }}
          </li>
          <li style="width: auto; padding-left: 8px">
            <div class="user blue" v-if="usetInfo">
              <!-- <img
                class="header_img"
                @click="link('home')"
                :src="header_w"
                alt=""
              /> -->
              <span @click="link('home')" class="stares">个人中心</span>|<span
                @click="link('loginout')"
                >退出登录</span
              >
            </div>
            <div class="user blue" v-else>
              <span @click="link('/login')">登录</span> |
              <span @click="link('register')">注册</span>
            </div>
          </li>
          <!-- <li :class="'activeee'">首页</li>
          <li :class="'activeee1'">版权登记</li>
          <li>版权交易</li>
          <li>版权维权</li>
          <li>信息公告</li>
          <li>帮助中心</li> -->
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import logo from "@/assets/V2/logo-V2.png";
import header_w from "@/assets/header/header_w.png";
import swiper from "vue-awesome-swiper/src/swiper.vue";
import swiperSlide from "vue-awesome-swiper/src/slide.vue";
import { mapState } from "vuex";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      list: [
        "首页",
        "版权登记",
        "版权交易",
        "华文链浏览器",
        "版权金融",
        "登记公告",
        "政策法规",
        "帮助中心",
      ],
      logo: logo,
      cur: 0,
      bg: [],
      bg2: [
        "https://img0.baidu.com/it/u=317876675,2999235592&fm=253&fmt=auto&app=138&f=JPEG?w=503&h=292",
        "https://img2.baidu.com/it/u=395246437,2043148743&fm=253&fmt=auto&app=138&f=PNG?w=438&h=273",
      ],
      header_w,
      usetInfo: window.localStorage.getItem("userInfo"),
      activeName: "",
    };
  },
  computed: {
    ...mapState(["bgc"]),

   
  },
  mounted() {
    var query = this.$route.query;
    console.log(query)
    if (sessionStorage.getItem("collegeCode")) {
      this.collegeCode = sessionStorage.getItem("collegeCode");
    }
    if (query.code) {
      console.log(query.code);
      this.collegeCode = query.code;
      sessionStorage.setItem("collegeCode", query.code);
    }
  },
  async created() {
    // window.localStorage.setItem(
    //             "V2Cur",
    //             JSON.stringify(res.user[0])
    // );

    this.activeName = this.$route.path.substring(1, this.$route.path.length);
    if (
      this.activeName == "" ||
      this.activeName == "/" ||
      this.activeName == "/index"
    ) {
      this.cur = 0;
    } else if (this.activeName == "rules") {
      this.cur = 6;
    }

    // if (window.localStorage.getItem("cur")) {
    //   this.cur = window.localStorage.getItem("cur");
    // }
    // if(this.bgc!=''){
    //   this.bg = [];
    //   window.localStorage
    //     .getItem("V2-bg")
    //     .split("|")
    //     .map((item, index) => {
    //       this.bg.push(this.$baseUrl + item);
    //     });
    // }else{

    // }

    if (window.localStorage.getItem("V2-bg")) {
      // this.bg = [];
      // window.localStorage
      //   .getItem("V2-bg")
      //   .split("|")
      //   .map((item, index) => {
      //     this.bg.push(this.$baseUrl + item);
      //   });
    } else {
      // var data = await this.$getHttp("pc/tShow/img");
      // this.bg = [];
      // data.list.img.split("|").map((item, index) => {
      //   this.bg.push(this.$baseUrl + item);
      // });
      // window.localStorage.setItem("V2-bg", data.list.img);
    }
    var data = await this.$getHttp("pc/tShow/img");
    var bg = [];
    console.log(data.list);
    if (data.list.length > 0) {
      data.list.map((item, index) => {
        bg.push({
          img: this.$baseUrl + item.img,
          remark: item.remarks || "",
        });
      });
    }

    this.$store.commit("setBgc", bg);
    window.localStorage.setItem("V2-bg", bg);
    console.log(this.bgc);

    // if (window.localStorage.getItem("V2-bg")) {
    //   var data = await this.$getHttp("pc/tShow/img");
    //   if (data.list.img != window.localStorage.getItem("V2-bg")) {
    //     window.localStorage.setItem("V2-bg", data.list.img);
    //     data.list.img.split("|").map((item, index) => {
    //       this.bg.push(this.$baseUrl + item);
    //     });
    //   }
    // }
  },
  methods: {
    swiperClick(item) {
      if (item.remark != "") {
        window.open(item.remark, "_target");
      }
      // console.log("111",item);
    },
    link(name) {
      console.log(name, "1111");
      if (name == "loginout") {
        sessionStorage.removeItem("userInfo");
        window.localStorage.removeItem("userInfo");
        this.$router.push("login");
      } else {
        sessionStorage.removeItem("form");

        // sessionStorage.removeItem('collegeCode')
        this.$router.push(name);
      }
    },
    nav(index) {
      // this.cur = index;
      // if (index == 5 || index == 0) {
      //   window.localStorage.setItem("cur", index);
      // }

      switch (index) {
        case 0:
          this.$router.push({ path: "/" });
          break;
        case 1:
          this.$router.push({ path: "/copyright" });
          break;
        case 2:
          this.$message({
            message: "此功能暂未开放",
            center: true,
          });
          break;
        case 3:
          window.open(
            `http://61.183.153.141:4700/`
          );
          break;

          let appId = "bqtmjqzh";
          // let appSecret = "3173ada5899c4bbf96bc4e275f5e2a3c";

          this.$getHttp("/pc/tShow/getToken").then((data) => {
            var accessToken = data.token;
            var timeStamp = new Date().getTime();
            window.open(
              `https://www.midu.com/midubqt/gateway/api/login/ssoLogin?timeStamp=${timeStamp}&systemId=${appId}&clientUserName=${appId}&channel=1&accessToken=${accessToken}`
            );
          });

          break;
        case 4:
          // this.$router.push({ path: "/help_center?id=1&type=page" });
          this.$router.push({
            path: "/finance",
            query: { id: 1 },
          });
          break;
        case 5:
          this.$router.push({ path: "/announcement" });
          break;
        case 6:
          this.$router.push({ path: "/rules" });
          break;
        case 7:
          this.$router.push({
            path: "/help_center",
            query: {
              id: 1,
            },
          });
          break;
        default:
        // 默认代码块
      }
    },
  },
};
</script>

<style lang='less' scoped>
/deep/ .el-carousel__container {
  height: 0;
  padding-bottom: 30%;
}
.header_img {
  width: 40px;
  background-color: transparent;
  height: 40px;
}
.pointer {
  cursor: pointer;
}
.activeee {
  color: #e60011 !important;
  font-weight: 500 !important;
  font-size: 26px !important;
  // transform: scale(1.08);

  &::after {
    content: "";
    display: block;
    position: absolute;
    right: 0%;
    top: 63px;
    // transform: translateX(-50%);
    width: 52px;
    height: 3px;
    background: #e60012;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
  }
}
.activeee1 {
  color: #e60011 !important;
  font-weight: 500 !important;
  font-size: 26px !important;
  &::after {
    content: "";
    display: block;
    position: absolute;
    right: 0%;
    top: 63px;
    // transform: translateX(-50%);
    width: 104px;
    height: 3px;
    background: #e60012;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
  }
}
.bqv2-header-wrapper {
  z-index: 9;
  // background-color: #453e3e;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100px;
  // background: rgba(0, 0, 0, 0.28);
  border-radius: 0px 0px 0px 0px;
  // opacity: 0.7;
  // background-color: rgba(255,255, 255, 0.3);
  // background-color: rgba(69, 63, 63, 0.88);
  background-color: #ffffff;
  filter: blur(0.3px);
}
.bqv2-header {
  padding-top: 100px;
  color: #333333;
  .bqv2-header-img {
    position: relative;

    width: 100%;
    // padding-bottom: 37.5%;
    // : url(img/1.jpg);
    background-size: cover;
    min-width: 1440px;
  }
  .bqv2-img {
    // width: 100%;
    // height: auto;
    cursor: pointer;
    background-size: 100% 100%;
  }
  .bqv2-header-title {
    // min-width: 1700px;
    margin: 0 auto;
    width: 1650px;
    height: 100px;
    // filter: blur(9px);

    display: flex;
    align-items: center;
    // justify-content: center;
    .bqv2-header-title-logo {
      vertical-align: middle;
      margin-left: 16px;
      width: 427px;
      height: auto;
    }
    .bqv2-header-title-content {
      // margin-left: 8px;
      letter-spacing: 0px;
      // margin-right: 53px;
      height: 45px;
      font-size: 32px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 45px;
      // -webkit-background-clip: text;
      // -webkit-text-fill-color: transparent;
    }

    ul {
      list-style: none;
      font-size: 20px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      li {
        cursor: pointer;
        position: relative;
        max-width: 124px;
        padding-left: 36px;
        // width: 124px;
        // width: 148px;
        // margin-right: 80px;
        text-align: right;
        float: left;
        // width: 96px;
        height: 33px;

        color: #333333;
        line-height: 33px;
        &:last-child {
          margin-right: 0px;
        }
      }
    }
  }
}
@media screen and (max-width: 1650px) {
  .activeee1 {
    font-size: 22px !important;
    &::after {
      width: 86px;
    }
  }
  .activeee {
    font-size: 22px !important;
    &::after {
      width: 43px;
    }
  }
}
@media screen and (max-width: 1650px) {
  .bqv2-header .bqv2-header-title {
  }
  .bqv2-header-title .bqv2-header-title-logo {
    margin-left: 0px !important;
  }
  .bqv2-header-title-content {
    margin-right: 32px !important;
    /* height: 45px; */
    font-size: 26px !important;
  }
  .bqv2-header-title ul {
    white-space: nowrap;
  }
  .bqv2-header-title ul li {
    font-size: 20px !important;
    margin-right: 18px !important;
  }
  .bqv2-header-title {
    margin: 0 auto !important;
    /* min-width: 1200px; */
    width: 1360px !important;
  }
  .bqv2-header .bqv2-header-title ul li {
    width: 86px !important;
  }
  .bqv2-header .bqv2-header-title ul li:first-child {
    width: 60px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/V2/components/header.vue